"use strict";

var _interopRequireDefault = require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _layout = _interopRequireDefault(require("@/layout"));
var _localstorage = _interopRequireDefault(require("@/utils/localstorage"));
var _index = _interopRequireDefault(require("@/store/index"));
var _Login = _interopRequireDefault(require("@/api/Login.js"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
_vue.default.use(_vueRouter.default);

// let homeUrl = db.get("HOME_URL", "").homeUrl;
var constRouter = [{
  path: '/redirect',
  component: _layout.default,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component(resolve) {
      return require(['@/views/redirect/index'], resolve);
    }
  }]
}, {
  path: '/404',
  component: function component(resolve) {
    return require(['@/views/error-page/404'], resolve);
  },
  hidden: true
}, {
  path: '/login',
  name: '登录页',
  component: function component(resolve) {
    return require(['@/views/login/index'], resolve);
  }
}, {
  path: '/login/login1',
  name: '登录页1',
  component: function component(resolve) {
    return require(['@/views/login/login1'], resolve);
  }
}, {
  path: '/middle',
  name: 'Middle',
  component: function component(resolve) {
    return require(['@/views/middle/index'], resolve);
  }
}, {
  path: '/favorites',
  name: 'Favorites',
  component: function component(resolve) {
    return require(['@/views/favorites/index'], resolve);
  }
}, {
  path: '/',
  component: _layout.default,
  redirect: '/dashboard/index'
  // redirect: to => {
  //   if (homeUrl) {
  //     return homeUrl
  //   } else {
  //     return '/dashboard'
  //   }
  // }
},
// 大屏
{
  path: '/screen',
  name: 'Screen',
  hidden: true,
  component: function component(resolve) {
    return require(['@/views/screen/index'], resolve);
  },
  meta: {
    isAuto: false
  }
}, {
  path: '/screenAuto',
  name: 'ScreenAuto',
  hidden: true,
  component: function component(resolve) {
    return require(['@/views/screen/index'], resolve);
  },
  meta: {
    isAuto: true
  }
}, {
  path: '/dashboard',
  component: _layout.default,
  redirect: '/dashboard/index',
  hidden: true,
  children: [{
    path: 'index',
    component: function component(resolve) {
      return require(['@/views/dashboard/index'], resolve);
    },
    name: 'Dashboard',
    meta: {
      title: 'dashboard',
      icon: 'dashboard',
      noCache: true
    }
  }]
}, {
  path: '/profile',
  component: _layout.default,
  redirect: '/profile/index',
  hidden: true,
  children: [{
    path: 'index',
    component: function component(resolve) {
      return require(['@/views/profile/index'], resolve);
    },
    name: 'Profile',
    meta: {
      title: 'profile',
      icon: 'user',
      noCache: true
    }
  }]
}, {
  path: '/supplies',
  component: _layout.default,
  redirect: '/supplies/management',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '物资管理',
    icon: '',
    noCache: true,
    breadcrumb: true
  },
  children: [{
    hidden: true,
    alwaysShow: false,
    path: '/supplies/directories/edit',
    component: function component(resolve) {
      return require(['@/views/azcs/supplies/directories/edit'], resolve);
    },
    name: '新增物资名录',
    meta: {
      title: '新增物资名录',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/supplies/directories/update',
    component: function component(resolve) {
      return require(['@/views/azcs/supplies/directories/update'], resolve);
    },
    name: '修改物资名录',
    meta: {
      title: '修改物资名录',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/supplies/directories/detail',
    component: function component(resolve) {
      return require(['@/views/azcs/supplies/directories/detail'], resolve);
    },
    name: '物资名录详情',
    meta: {
      title: '物资名录详情',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/supplies/inventory/detail',
    component: function component(resolve) {
      return require(['@/views/azcs/supplies/inventory/detail'], resolve);
    },
    name: '库存物资详情',
    meta: {
      title: '库存物资详情',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }]
}, {
  path: '/resources',
  component: _layout.default,
  redirect: '/resources/msg',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '资源中心',
    icon: '',
    noCache: true,
    breadcrumb: true
  },
  children: [{
    hidden: true,
    alwaysShow: false,
    path: '/resources/msg/edit',
    component: function component(resolve) {
      return require(['@/views/azcs/resources/msg/edit'], resolve);
    },
    name: '发送消息',
    meta: {
      title: '发送消息',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    path: '/resources/sms/edit',
    component: function component(resolve) {
      return require(['@/views/azcs/resources/sms/edit'], resolve);
    },
    name: 'smsEdit',
    meta: {
      title: '发送短信',
      icon: '',
      noCache: true
    }
  }]
}, {
  path: '/task',
  component: _layout.default,
  redirect: '/task/list',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '任务列表',
    icon: '',
    noCache: true,
    breadcrumb: true
  },
  children: [{
    hidden: true,
    alwaysShow: false,
    path: '/task/list/detail',
    component: function component(resolve) {
      return require(['@/views/azcs/task/list/detail'], resolve);
    },
    name: 'taskListDetail',
    meta: {
      title: '任务详情',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/task/customTemplate/template',
    component: function component(resolve) {
      return require(['@/views/azcs/task/customTemplate/template'], resolve);
    },
    name: 'Template',
    meta: {
      title: '编辑任务模板',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/task/customTemplate/detail',
    component: function component(resolve) {
      return require(['@/views/azcs/task/customTemplate/detail'], resolve);
    },
    name: 'TemplateDetail',
    meta: {
      title: '任务模板详情',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/task/list/particulars',
    component: function component(resolve) {
      return require(['@/views/azcs/task/list/particulars'], resolve);
    },
    name: 'Particulars',
    meta: {
      title: '任务明细',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }]
}, {
  path: '/place',
  component: _layout.default,
  redirect: '/place/list',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '场所列表',
    icon: '',
    noCache: true,
    breadcrumb: true
  },
  children: [{
    hidden: true,
    alwaysShow: false,
    path: '/place/list/create',
    component: function component(resolve) {
      return require(['@/views/azcs/place/list/create'], resolve);
    },
    name: 'PlaceCreate',
    meta: {
      title: '编辑场所',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/place/list/detail',
    component: function component(resolve) {
      return require(['@/views/azcs/place/list/detail'], resolve);
    },
    name: 'PlaceDetail',
    meta: {
      title: '场所详情',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }]
}, {
  path: '/supplies',
  component: _layout.default,
  redirect: '/supplies/adjustment',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '库存调整',
    icon: '',
    noCache: true,
    breadcrumb: true
  },
  children: [{
    hidden: true,
    alwaysShow: false,
    path: '/supplies/adjustment/create',
    component: function component(resolve) {
      return require(['@/views/azcs/supplies/adjustment/create'], resolve);
    },
    name: 'adjustmentCreate',
    meta: {
      title: '编辑库存',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }]
}, {
  path: '/people',
  component: _layout.default,
  redirect: '/people/adminList',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '场所管理员列表',
    icon: '',
    noCache: true,
    breadcrumb: true
  },
  children: [{
    hidden: true,
    alwaysShow: false,
    path: '/people/adminList/create',
    component: function component(resolve) {
      return require(['@/views/azcs/people/adminList/create'], resolve);
    },
    name: 'peopleAdminCreate',
    meta: {
      title: '编辑管理员',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/people/adminList/detail',
    component: function component(resolve) {
      return require(['@/views/azcs/people/adminList/detail'], resolve);
    },
    name: 'AdminDetail',
    meta: {
      title: '管理员详情',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/people/keyPersonnel/create',
    component: function component(resolve) {
      return require(['@/views/azcs/people/keyPersonnel/create'], resolve);
    },
    name: 'keyPersonnelCreate',
    meta: {
      title: '编辑重点服务人员',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/people/keyPersonnel/detail',
    component: function component(resolve) {
      return require(['@/views/azcs/people/keyPersonnel/detail'], resolve);
    },
    name: 'keyPersonnelDetail',
    meta: {
      title: '重点服务人员详情',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }]
}, {
  path: '/workbench',
  component: _layout.default,
  redirect: '/workbench/notice',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '工作台',
    icon: '',
    noCache: true,
    breadcrumb: true
  },
  children: [{
    hidden: true,
    alwaysShow: false,
    path: '/workbench/notice/edit',
    component: function component(resolve) {
      return require(['@/views/azcs/workbench/notice/edit'], resolve);
    },
    name: '编辑通知',
    meta: {
      title: '编辑通知',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/workbench/notice/detail',
    component: function component(resolve) {
      return require(['@/views/azcs/workbench/notice/detail'], resolve);
    },
    name: '查看通知',
    meta: {
      title: '查看通知',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/workbench/manual/edit',
    component: function component(resolve) {
      return require(['@/views/azcs/workbench/manual/edit'], resolve);
    },
    name: '编辑手册',
    meta: {
      title: '编辑手册',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }, {
    hidden: true,
    alwaysShow: false,
    path: '/workbench/manual/detail',
    component: function component(resolve) {
      return require(['@/views/azcs/workbench/manual/detail'], resolve);
    },
    name: '手册详情',
    meta: {
      title: '手册详情',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }]
}, {
  path: '/message',
  component: _layout.default,
  redirect: '/message/smsTask',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '短信群发',
    icon: '',
    noCache: true,
    breadcrumb: true
  },
  children: [{
    hidden: true,
    alwaysShow: false,
    path: '/message/smsTask/create',
    component: function component(resolve) {
      return require(['@/views/azcs/message/smsTask/create'], resolve);
    },
    name: 'smsTaskCreate',
    meta: {
      title: '短信群发',
      icon: '',
      noCache: true,
      breadcrumb: true
    }
  }]
}, {
  path: '/error',
  component: _layout.default,
  redirect: 'noRedirect',
  name: 'ErrorPages',
  meta: {
    title: 'errorPages',
    icon: '404'
  },
  children: [{
    path: '404',
    component: function component(resolve) {
      return require(['@/views/error-page/404'], resolve);
    },
    name: 'Page404',
    meta: {
      title: 'page404',
      noCache: true
    }
  }]
}];
var router = new _vueRouter.default({
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: constRouter
});
var whiteList = ['/login', '/login/login1', '/middle', '/favorites'];
// 异步的路由信息， 同时，左侧菜单也会根据这个来显示
var asyncRouter;

// 导航守卫，渲染动态路由
router.beforeEach(function (to, from, next) {
  _nprogress.default.start();
  if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else {
    var token = _localstorage.default.get('TOKEN', '');
    var user = _localstorage.default.get('USER');
    var userRouter = _localstorage.default.get('USER_ROUTER', ''); //缓存中的路由
    if (token && token.length && user) {
      if (!asyncRouter) {
        if (!userRouter) {
          _Login.default.getRouter({}).then(function (response) {
            var res = response.data;
            asyncRouter = res.data;
            if (!(asyncRouter && asyncRouter.length > 0)) {
              asyncRouter = [];
            }
            asyncRouter.push({
              alwaysShow: false,
              component: "error-page/404",
              hidden: false,
              name: "404",
              path: "*"
            });
            _index.default.commit('account/setRoutes', asyncRouter);
            go(to, next);
          });
        } else {
          asyncRouter = userRouter;
          go(to, next);
        }
      } else {
        if (to.path == '/supplies/out/detail') {
          // to.meta.title = db.get('sRouteTitle', '出库单详情')
        }
        next();
      }
    } else {
      if (to.path === '/login') {
        next();
      } else {
        _localstorage.default.clear();
        next('/login');
      }
    }
  }
});
router.afterEach(function () {
  _nprogress.default.done();
});
function go(to, next) {
  asyncRouter = filterAsyncRouter(asyncRouter);
  router.addRoutes(asyncRouter);
  next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
    replace: true
  }));
}
function filterAsyncRouter(routes, parent) {
  return routes.filter(function (route) {
    var component = route.component;
    if (component) {
      if (route.component === 'Layout') {
        if (route.children && route.children.length > 0 && parent) {
          route.component = function (resolve) {
            require(['@/components/RouterWrap/RouterWrap.vue'], resolve);
          };
        } else {
          route.component = _layout.default;
        }
      } else if (typeof component === 'string') {
        route.component = view(component);
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, route);
      }
      return true;
    }
  });
}
function view(path) {
  return function (resolve) {
    require(["@/views/".concat(path, ".vue")], resolve);
  };
}
var _default = router;
exports.default = _default;